import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

const rootElementIds = [
	"jFtriggerHero",
	"jFtrigger",
	"jFtriggerMb",
	"jFconsulation",
	"jFtriggerBlog",
];

rootElementIds.forEach((id) => {
	const rootElement = document.getElementById(id);
	if (rootElement && !rootElement.dataset.reactRendered) {
		const root = ReactDOM.createRoot(rootElement);
		root.render(
			<React.StrictMode>
				<App key={id} rootElement={rootElement} />
			</React.StrictMode>
		);
		rootElement.dataset.reactRendered = "true";
	}
});
